export function isCloseIcon(target) {
  var _target$className = target.className,
    className = _target$className === void 0 ? '' : _target$className;
  return className.includes && className.includes('close') && className.includes('icon');
}
export function isSocialMediaIcon(target) {
  var _target$className2 = target.className,
    className = _target$className2 === void 0 ? '' : _target$className2;
  return className.includes && className.includes('social-platform-icon');
}